import {
  zkSync,
  mainnet,
  polygon,
  avalanche,
  bsc,
  goerli,
  polygonMumbai,
} from "wagmi/chains";
export const BSCIcon = "/airdrop_assets/network/bsc.png";
export const EthereumIcon = "/airdrop_assets/network/ethereum.png";
export const PolygonIcon = "/airdrop_assets/network/polygon-matic-logo.png";
export const AvalancheIcon = "/airdrop_assets/network/avalanche-avax-logo.png";

export const AvailableNetworks = [
  {
    config: mainnet,
    name: "Ethereum",
    isTestNetwork: false,
    icon: EthereumIcon,
  },
  {
    config: polygon,
    name: "Polygon",
    isTestNetwork: false,
    icon: PolygonIcon,
  },
  {
    config: avalanche,
    name: "Avalanche",
    isTestNetwork: false,
    icon: AvalancheIcon,
  },
  {
    config: bsc,
    name: "BSC",
    isTestNetwork: false,
    icon: BSCIcon,
  },
  {
    config: zkSync,
    name: "zkSync",
    isTestNetwork: false,
    icon: "https://portal.zksync.io/favicon.ico",
  },
  {
    config: goerli,
    name: "Goerli",
    isTestNetwork: true,
    icon: EthereumIcon,
  },
];

if (process.env.NODE_ENV !== "production") {
  AvailableNetworks.push({
    config: polygonMumbai as any,
    name: "Mumbai",
    isTestNetwork: true,
    icon: PolygonIcon,
  });
}
